/** Godziny prezentowane na stronie (kontakt, stopka). */
export const BUSINESS_HOURS_WEEKDAYS = "Pon–pt: 7:00–20:00";
export const BUSINESS_HOURS_WEEKEND = "Sob–niedz: 7:00–20:00";
